import AppLayout from '@/components/layout/AppLayout';
import { UploadWizard } from '@/components/upload/UploadWizard';

const Upload = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Upload Portfolio</h1>
          <p className="text-muted-foreground">
            Import your debt portfolio from CSV or Excel
          </p>
        </div>

        <UploadWizard />
      </div>
    </AppLayout>
  );
};

export default Upload;
